(function() {
    angular
        .module("app")
        .controller("DeleteCustomerModalController", DeleteCustomerModalController)

    DeleteCustomerModalController.$inject = [
        "$state",
        "$rootScope",
        "$scope",
        "$window",
        "$uibModalInstance",
        "customersService",
        "userMessagingService",
        "customer"
    ]

    function DeleteCustomerModalController(
        $state,
        $rootScope,
        $scope,
        $window,
        $uibModalInstance,
        customersService,
        userMessagingService,
        customer
    ){
        "use strict"

        $scope.customer = {
            name: customer.name
        }

        $scope.ok = () => {

            const success = () => {

                gtag("event", "delete_customer", { customer_id: customer.id })

                // Need to get a new list of customers from server because deleting a customer will also delete all children
                customersService.getCustomers(function(data) {
                    $rootScope.customers = data

                    $state.go("customers", {}).then(() => {
                        userMessagingService.success("Customer Successfully Deleted")
                    })
                })
            }

            const failure = (error) => {
                userMessagingService.error(error)
            }

            $uibModalInstance.close(customersService.deleteCustomer(customer.id, success, failure))
        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
